import React from 'react';
import WeightGainPage from './weightGainPage';
import WeightLossPage from './weightLossPage';

const ReachYourWeight = (data) => {

    const userWeight = data.data.currentWeight.value;
    const userGoalWeight = data.data.goalWeight.value;
    const weightType = data.data.currentWeight.type;

  return (
    <>
    {userWeight > userGoalWeight ?
        <WeightLossPage 
          currentWeight={userWeight}
          goalWeight={userGoalWeight}
          weightType={weightType}
        />
    :
        <WeightGainPage 
          currentWeight={userWeight}
          goalWeight={userGoalWeight}
          weightType={weightType}
        />
    }
    </>
      
  )
}

export default ReachYourWeight;